import { useCreateMutation } from '../../../../../../lib/utils/createMutation';
import ReviewApiV2 from '../../../../../../lib/api/cs/review/ReviewApiV2';
import { UseMutationResult } from '@tanstack/react-query';
import { ReviewCreateResponseType } from '../../types/ReviewCreateResponseType';
import { ReviewCreateRequestType } from '../../types/ReviewCreateRequestType';
import { AxiosError } from 'axios';
import { ReviewCreateErrorResponseType } from '../../types/ReviewCreateErrorResponseType';

import { useNavigate } from 'react-router-dom';

import { showErrorMessages } from '../../util/util';

const useCreateForm = (): UseMutationResult<ReviewCreateResponseType, unknown, ReviewCreateRequestType, unknown> => {
  const navigate = useNavigate();
  return useCreateMutation<ReviewCreateRequestType, ReviewCreateResponseType>({
    queryKey: ['updateForm'],
    apiFunction: (payload: ReviewCreateRequestType) => ReviewApiV2.createReview(payload),
    onSuccess: () => {
      navigate('/cs/review/list');
    },
    onError: (error: AxiosError) => {
      const data = error?.response?.data as { errors?: ReviewCreateErrorResponseType[] };
      showErrorMessages(data.errors || []);
    },
  });
};

export default useCreateForm;
